import * as _monaco from 'monaco-editor';
import { IGrammarDefinition, Registry } from 'monaco-textmate';

const tmScopeName = 'source.drools';
const monacoId = 'drools';
const extensions = ['.drl'];
const monarchLanguageConfiguration: _monaco.languages.LanguageConfiguration = {
  wordPattern: /(-?\d*\.\d\w*)|([^`~!#%^&*()\-=+[{\]}\\|;:'",.<>/?\s]+)/g,
  comments: {
    // symbol used for single line comment. Remove this entry if your language does not support line comments
    lineComment: '//',
    // symbols used for start and end a block comment. Remove this entry if your language does not support block comments
    blockComment: ['/*', '*/'],
  },
  // symbols used as brackets
  brackets: [
    ['{', '}'],
    ['[', ']'],
    ['(', ')'],
  ],
  // symbols that are auto closed when typing
  autoClosingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
    { open: "'", close: "'" },
    { open: '/*', close: '*/' },
  ],
  // symbols that that can be used to surround a selection
  surroundingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
    { open: "'", close: "'" },
  ],
  folding: {
    markers: {
      start: new RegExp('^\\s*//\\s*(?:(?:#?region\\b)|(?:<editor-fold\\b))'),
      end: new RegExp('^\\s*//\\s*(?:(?:#?endregion\\b)|(?:</editor-fold>))'),
    },
  },
};
const monarchLanguage: _monaco.languages.IMonarchLanguage = {
  defaultToken: '',
  tokenizer: {
    root: [[/[{}]/, 'delimiter.bracket'], { include: 'common' }],
    common: [
      [
        /#?[a-z_$][\w$]*/,
        {
          cases: {
            '@keywords': 'keyword',
            '@default': 'identifier',
          },
        },
      ],
    ],
  },
  keywords: [
    'lock-on-active',
    'date-effective',
    'date-expires',
    'no-loop',
    'auto-focus',
    'activation-group',
    'agenda-group',
    'ruleflow-group',
    'entry-point',
    'duration',
    'package',
    'import',
    'dialect',
    'salience',
    'enabled',
    'attributes',
    'rule',
    'extends',
    'when',
    'then',
    'template',
    'query',
    'declare',
    'function',
    'global',
    'eval',
    'not',
    'in',
    'or',
    'and',
    'exists',
    'forall',
    'accumulate',
    'collect',
    'from',
    'end',
    'over',
    'calendars',
    'init',
    'action',
    'reverse',
    'result',
    'new',
    'true',
    'false',
    'null',
    'insert',
    'insertLogical',
    'delete',
    'modify',
  ],
  operators: ['<', '>', '==', '<=', '>=', '.', '!='],
};

function getRegistry(): Registry {
  return new Registry({
    getGrammarDefinition: async (scopeName: string): Promise<IGrammarDefinition> => {
      let res!: IGrammarDefinition;
      if (scopeName === tmScopeName) {
        res = {
          format: 'json',
          content: await (await fetch('assets/drools/Drools.tmLanguage.json')).text(),
        };
      }
      return res;
    },
  });
}

export const drools = {
  tmScopeName,
  monacoId,
  extensions,
  monarchLanguageConfiguration,
  monarchLanguage,
  getRegistry,
};
